import { TableCard } from '../../../../components'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { PareceresListHeader } from './components/header/PareceresListHeader'
import { PareceresTable } from './table/PareceresTable'
import { EscopoPareceres, EscopoPareceresProvider } from './core/escopoPareceres'

const PareceresList = () => {
  return (
    <TableCard>
      <PareceresListHeader />
      <PareceresTable />
    </TableCard>
  )
}

type Props = {
  escopo?: EscopoPareceres
}

export const PareceresListWrapper = ({ escopo = 'minhas' }: Props) => (
  <EscopoPareceresProvider value={escopo}>
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListFiltersProvider>
          <PareceresList />
        </ListFiltersProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  </EscopoPareceresProvider>
)
